module.exports = __webpack_public_path__ + "img/SOKAL-SRS-121021-Eclipse-Playful.f1b3fab3.jpeg";